import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableMongoDB from './TableMongoDB';
import { fetchProjectTables, removeProjectTables, fetchProjects } from 'store/slices/project';

/**
 * MongoDB Module Page
 * Wrapper component for MongoDB table management
 * Route: /workspace/storage/:projectId/mongodb
 */
const MongoDBModulePage = ({ projectName, projectSubname, onBack }) => {
    const dispatch = useDispatch();
    const projectsState = useSelector((state) => state.project);
    const [isLoading, setIsLoading] = React.useState(false);

    useEffect(() => {
        if (projectName) {
            setIsLoading(true);
            dispatch(fetchProjectTables(projectName)).finally(() => setIsLoading(false));
        }
    }, [projectName, dispatch]);

    const handleBack = () => {
        dispatch(removeProjectTables());
        dispatch(fetchProjects());
        onBack();
    };

    return (
        <TableMongoDB
            onClick={handleBack}
            folderName={projectName}
            projectSubname={projectSubname}
            dataMongoDBTable={projectsState?.tables}
            fetchProjectTables={() => {
                dispatch(fetchProjectTables(projectName));
            }}
            isSetting={false}
        />
    );
};

export default MongoDBModulePage;
